import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

export const downloadPdfInvoiceData = month =>
  axios.get(`${API_HOST}/invoice/download/${month}`, {
    withCredentials: true,
    responseType: 'arraybuffer'
  });

export default downloadPdfInvoiceData;
